import { cn } from "@/lib/utils";

const SingleStepIndicator = ({ isActive }: { isActive: boolean }) => {
  return (
    <div
      className={cn(
        "relative h-1 flex-1 self-stretch overflow-hidden rounded-full bg-zinc-200",
        isActive && "bg-remedium-blue",
      )}
    ></div>
  );
};

export const CourseChapterTestProgressIndicator = ({
  currentStep,
  totalSteps,
  prefixText = "",
}: {
  currentStep: number;
  totalSteps: number;
  prefixText?: string;
}) => {
  return (
    <div className="flex items-center gap-6">
      <p className="text-muted-foreground text-xs">
        {prefixText} {currentStep + 1}/{totalSteps}
      </p>
      <div className="flex h-1 flex-1 items-center gap-1">
        {Array.from({ length: totalSteps }).map((_, idx) => (
          <SingleStepIndicator key={idx} isActive={idx <= currentStep} />
        ))}
      </div>
    </div>
  );
};
